// extracted by mini-css-extract-plugin
export default {"panel":"Results-module__panel___YTHEd","collectionSection":"Results-module__collectionSection___jAMH1","header":"Results-module__header___cLflU"};